<ng-content select=".avla_modal_section__outsideaction"></ng-content>
<div class="avla_modal" [ngClass]="getClassess">
    <div class="avla_modal__box" [class]="{'full-width':fullWidth}">
        <button class="avla_modal__box__close-button" (click)="toggle($event)" *ngIf="type !== 'no-x-close'">
            <app-icon name="close" size="20"></app-icon>
        </button>
        <div class="avla_modal__box__content" >
            <div *ngIf="hasShadow" class="avla-modal__box__shadow__content"></div>
            <div class="avla_modal__box__content__header">
                <ng-content select=".avla_modal_section__header"></ng-content>
            </div>
            <div class="avla_modal__box__content__body">
                <ng-content select=".avla_modal_section__body"></ng-content>
            </div>
            <div class="avla_modal__box__content__footer">
                <ng-content select=".avla_modal_section__footer"></ng-content>
            </div>
        </div>
    </div>
</div>